import { BaseApi } from './base.api.js';

export class TransferTypeApi extends BaseApi {
    constructor(client) {
        super(client, '/transfer-type');
    }
}
